var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"title"},[_vm._m(0),_c('a-input-search',{staticStyle:{"width":"600px"},attrs:{"placeholder":"请输入芯片型号","enter-button":"查询一下","size":"large"},on:{"search":_vm.onSearch},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../assets/logo1.png")}})])
}]

export { render, staticRenderFns }